export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const UPDATE_RETAILER = 'UPDATE_RETAILER'
export const REPLACE_RETAILER = 'REPLACE_RETAILER'
export const UPLOAD_COMPANY_LOGO_RESPONSE = 'UPLOAD_COMPANY_LOGO_RESPONSE'
export const UPLOAD_COMPANY_LOGO_SCANNING = 'UPLOAD_COMPANY_LOGO_SCANNING'
export const UPLOAD_COMPANY_LOGO_SCAN_FAILED = 'UPLOAD_COMPANY_LOGO_SCAN_FAILED'
